import { render, staticRenderFns } from "./PageStats.vue?vue&type=template&id=00241a0b&"
import script from "./PageStats.vue?vue&type=script&lang=js&"
export * from "./PageStats.vue?vue&type=script&lang=js&"
import style0 from "./PageStats.vue?vue&type=style&index=0&id=00241a0b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports